import * as i0 from '@angular/core';
import { Pipe, NgModule } from '@angular/core';
import * as i1 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import insane from 'insane';
import { decode } from 'he';
import striptags from 'striptags';
import { CommonModule } from '@angular/common';
import * as i1$1 from '@angular/platform-browser';

class BreakLinesPipe {
    transform(value) {
        return ('' + value).replace(/\n/g, '<br>');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: BreakLinesPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.10", ngImport: i0, type: BreakLinesPipe, name: "sbBreakLines" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: BreakLinesPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'sbBreakLines',
                }]
        }] });
const DIRECTIVES$4 = [BreakLinesPipe];
class BreakLinesPipeModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: BreakLinesPipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.10", ngImport: i0, type: BreakLinesPipeModule, declarations: [BreakLinesPipe], exports: [BreakLinesPipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: BreakLinesPipeModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: BreakLinesPipeModule, decorators: [{
            type: NgModule,
            args: [{
                    exports: DIRECTIVES$4,
                    declarations: DIRECTIVES$4,
                }]
        }] });

const START_AFTERNOON = 12;
const START_EVENING = 18;
function resolveGreetingTiming(time) {
    if (time < START_AFTERNOON)
        return 'morning';
    if (time < START_EVENING)
        return 'afternoon';
    return 'evening';
}
class GreetPipe {
    constructor(translate) {
        this.translate = translate;
    }
    transform(value) {
        const currentHour = new Date().getHours();
        const timing = resolveGreetingTiming(currentHour);
        return this.translate.instant(`Good ${timing}, {{name}}`, { name: value });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: GreetPipe, deps: [{ token: i1.TranslateService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.10", ngImport: i0, type: GreetPipe, name: "sbGreet" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: GreetPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'sbGreet',
                }]
        }], ctorParameters: () => [{ type: i1.TranslateService }] });
const DIRECTIVES$3 = [GreetPipe];
class GreetPipeModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: GreetPipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.10", ngImport: i0, type: GreetPipeModule, declarations: [GreetPipe], imports: [TranslateModule], exports: [GreetPipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: GreetPipeModule, imports: [TranslateModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: GreetPipeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [TranslateModule],
                    exports: DIRECTIVES$3,
                    declarations: DIRECTIVES$3,
                }]
        }] });

const CSS_ATTRIBUTES = ['class', 'style'];
const options = {
    allowedTags: insane.defaults.allowedTags.concat(['svg', 'g', 'path']),
    allowedAttributes: {
        a: [...CSS_ATTRIBUTES, 'href', 'name', 'target', 'rel'],
        svg: ['*'],
        g: ['*'],
        path: ['*'],
        '*': CSS_ATTRIBUTES,
        // TODO: Remove the following once the "insane" library is fixed at npm
        h1: CSS_ATTRIBUTES,
        h2: CSS_ATTRIBUTES,
        h3: CSS_ATTRIBUTES,
        h4: CSS_ATTRIBUTES,
        h5: CSS_ATTRIBUTES,
        h6: CSS_ATTRIBUTES,
        p: CSS_ATTRIBUTES,
        ul: CSS_ATTRIBUTES,
        ol: CSS_ATTRIBUTES,
        li: [...CSS_ATTRIBUTES, 'data-list'],
        span: CSS_ATTRIBUTES,
        b: CSS_ATTRIBUTES,
        i: CSS_ATTRIBUTES,
        u: CSS_ATTRIBUTES,
        strike: CSS_ATTRIBUTES,
        sub: CSS_ATTRIBUTES,
        sup: CSS_ATTRIBUTES,
    },
};
class SanitizeHtmlPipe {
    transform(value) {
        const html = insane(`${value}`, options);
        return html.length ? html : '&nbsp;';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: SanitizeHtmlPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.10", ngImport: i0, type: SanitizeHtmlPipe, name: "sbSanitizeHtml" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: SanitizeHtmlPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'sbSanitizeHtml',
                }]
        }] });
const DIRECTIVES$2 = [SanitizeHtmlPipe];
class SanitizeHtmlPipeModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: SanitizeHtmlPipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.10", ngImport: i0, type: SanitizeHtmlPipeModule, declarations: [SanitizeHtmlPipe], exports: [SanitizeHtmlPipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: SanitizeHtmlPipeModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: SanitizeHtmlPipeModule, decorators: [{
            type: NgModule,
            args: [{
                    exports: DIRECTIVES$2,
                    declarations: DIRECTIVES$2,
                }]
        }] });

class StripHtmlPipe {
    transform(value) {
        return decode(striptags('' + value));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: StripHtmlPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.10", ngImport: i0, type: StripHtmlPipe, name: "sbStripHtml" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: StripHtmlPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'sbStripHtml',
                }]
        }] });
const DIRECTIVES$1 = [StripHtmlPipe];
class StripHtmlPipeModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: StripHtmlPipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.10", ngImport: i0, type: StripHtmlPipeModule, declarations: [StripHtmlPipe], exports: [StripHtmlPipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: StripHtmlPipeModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: StripHtmlPipeModule, decorators: [{
            type: NgModule,
            args: [{
                    exports: DIRECTIVES$1,
                    declarations: DIRECTIVES$1,
                }]
        }] });

class TrustHtmlPipe {
    constructor(_domSanitizer) {
        this._domSanitizer = _domSanitizer;
    }
    transform(value) {
        return this._domSanitizer.bypassSecurityTrustHtml('' + value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: TrustHtmlPipe, deps: [{ token: i1$1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.10", ngImport: i0, type: TrustHtmlPipe, name: "sbTrustHtml" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: TrustHtmlPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'sbTrustHtml',
                }]
        }], ctorParameters: () => [{ type: i1$1.DomSanitizer }] });
const DIRECTIVES = [TrustHtmlPipe];
class TrustHtmlPipeModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: TrustHtmlPipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.10", ngImport: i0, type: TrustHtmlPipeModule, declarations: [TrustHtmlPipe], imports: [CommonModule], exports: [TrustHtmlPipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: TrustHtmlPipeModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: TrustHtmlPipeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: DIRECTIVES,
                    declarations: DIRECTIVES,
                }]
        }] });

class TextModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: TextModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.10", ngImport: i0, type: TextModule, exports: [GreetPipeModule,
            StripHtmlPipeModule,
            SanitizeHtmlPipeModule,
            TrustHtmlPipeModule,
            BreakLinesPipeModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: TextModule, imports: [GreetPipeModule,
            StripHtmlPipeModule,
            SanitizeHtmlPipeModule,
            TrustHtmlPipeModule,
            BreakLinesPipeModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: TextModule, decorators: [{
            type: NgModule,
            args: [{
                    exports: [
                        GreetPipeModule,
                        StripHtmlPipeModule,
                        SanitizeHtmlPipeModule,
                        TrustHtmlPipeModule,
                        BreakLinesPipeModule,
                    ],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { BreakLinesPipe, BreakLinesPipeModule, GreetPipe, GreetPipeModule, SanitizeHtmlPipe, SanitizeHtmlPipeModule, StripHtmlPipe, StripHtmlPipeModule, TextModule, TrustHtmlPipe, TrustHtmlPipeModule };
